<template>
  <div>
    <Header>
      <template #title>
        {{ $t("settings_cafe.title") }}
      </template>
    </Header>

    <PageContainer>
      <div class="iqos-grid">
        <div class="iqos-column">
          <CafeInfoPanel />
          <RegionalSettingsPanel />
          <!-- <ScheduleEditor :mode="'general'" /> -->
        </div>
        <div class="iqos-column">
          <CafeLogosPanel />
          <CafeAddressPanel />
          <OnlineMenuLinkCard />
          <ContactDataPanel />
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import ScheduleEditor from '@/components/schedule/CafeScheduleEditor.vue'
import PaymentCard from '@/components/PaymentCard.vue'
import MinCheckPanel from '@/components/MinCheckPanel.vue'
import CafeInfoPanel from '@/components/general/CafeInfoPanel.vue'
import ContactDataPanel from '@/components/general/ContactDataPanel.vue'
import OnlineMenuLinkCard from '@/components/general/OnlineMenuLinkCard.vue'
import PayReceiver from '@/components/PayReceiver.vue'
import CurrencyPanel from '@/components/CurrencyPanel.vue'
import SocialNetworksPanel from '@/components/SocialNetworksPanel.vue'
import ServingFeePanel from '@/components/general/ServingFeePanel.vue'
import TaxesFeePanel from '@/components/general/TaxesFeePanel.vue'
import RegionalSettingsPanel from '@/components/general/RegionalSettingsPanel.vue'
import SecurityPanel from '@/components/general/SecurityPanel.vue'
import CafeLogosPanel from '@/components/general/CafeLogosPanel.vue'

import CafeAddressPanel from '@/components/general/CafeAddressPanel.vue'

export default {
  components: {
    ScheduleEditor,
    PaymentCard,
    MinCheckPanel,
    CafeInfoPanel,
    ContactDataPanel,
    OnlineMenuLinkCard,
    PayReceiver,
    CurrencyPanel,
    SocialNetworksPanel,
    ServingFeePanel,
    TaxesFeePanel,
    RegionalSettingsPanel,
    CafeAddressPanel,
    SecurityPanel,
    CafeLogosPanel,
    OnlineMenuLinkCard
  }
}
</script>

<style></style>
